/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'thermometer': {
    width: 16,
    height: 16,
    viewBox: '0 0 10 21',
    data: '<path pid="0" d="M4 14.268A2 2 0 0 0 3 16a2 2 0 0 0 2 2 2 2 0 0 0 2-2 2 2 0 0 0-1-1.732V4a1 1 0 0 0-1-1 1 1 0 0 0-1 1zM9 13a4.329 4.329 0 0 1 1 3.111A4.946 4.946 0 0 1 5 21a4.945 4.945 0 0 1-5-4.889A4.329 4.329 0 0 1 1 13V4a4.226 4.226 0 0 1 4-4 4.226 4.226 0 0 1 4 4z"/>'
  }
})
